import { RawScrapesiteData } from './types';

export class ScrapesiteModel {
  id: string;
  name: string;
  image: string;

  constructor(rawScrapesiteData: RawScrapesiteData) {
    this.id = rawScrapesiteData.id;
    this.name = rawScrapesiteData.name;
    this.image = rawScrapesiteData.image;
  }
}